var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4962 22.5008L22.5 22.4998V16.9986C22.5 14.307 21.9206 12.2342 18.7743 12.2342C17.2622 12.2342 16.2468 13.0639 15.8325 13.8514H15.7893V12.4855H12.8062V22.4998H15.9131V17.5414C15.9131 16.2354 16.1606 14.9736 17.7778 14.9736C19.3706 14.9736 19.395 16.4633 19.395 17.6258V22.5008H22.4962Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7475 12.4851H10.8572V22.4997H7.7475V12.4851Z",
    fill: "#DDDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30094 7.5C8.30719 7.5 7.5 8.30719 7.5 9.30094C7.5 10.2956 8.30719 11.1187 9.30094 11.1187C10.2947 11.1187 11.1019 10.2956 11.1019 9.30094C11.1019 8.30719 10.2947 7.5 9.30094 7.5V7.5Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a6b411850ee6cf81ecb1bb709e4101ea.svg";
export { ForwardRef as ReactComponent };